/*
 Selectively import from Bootstrap what you need: (add modules to exports to prevent tree shaking, see below)
 */
// import Alert from 'bootstrap/js/dist/alert'
import Button from 'bootstrap/js/dist/button'
// import Carousel from 'bootstrap/js/dist/carousel';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown'
import Modal from 'bootstrap/js/dist/modal';
// import Offcanvas from 'bootstrap/js/dist/offcanvas'
// import Popover from 'bootstrap/js/dist/popover'
// import ScrollSpy from 'bootstrap/js/dist/scrollspy'
// import Tab from 'bootstrap/js/dist/tab'
// import Toast from 'bootstrap/js/dist/toast'
// import Tooltip from 'bootstrap/js/dist/tooltip'
import '../JavaScript/site-init.mjs';
/*
 CSS files are compiled by being imported in JS – that's just a way to tell the build system; they are not actually
 included in JS. They get the same base name as the JS entry point they are imported in.
 */
import '../Scss/site.scss';

// prevent tree shaking
export {
  Button,
  Collapse,
  Dropdown,
  Modal,
};

export class Site {

}

new Site();
